import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["required", "aria-required"]
const _hoisted_2 = ["required", "aria-required"]
const _hoisted_3 = ["required", "aria-required"]
const _hoisted_4 = {
  key: 0,
  value: "-1"
}
const _hoisted_5 = {
  key: 1,
  value: "0001"
}
const _hoisted_6 = {
  key: 2,
  value: "0002"
}
const _hoisted_7 = {
  key: 3,
  value: "0003"
}
const _hoisted_8 = {
  key: 4,
  value: "0004"
}
const _hoisted_9 = {
  key: 5,
  value: "0005"
}
const _hoisted_10 = {
  key: 6,
  value: "0006"
}
const _hoisted_11 = { class: "u-remove-list-styles" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["min", "required", "aria-required", "data-fehlermeldung"]
const _hoisted_14 = ["required", "aria-required"]
const _hoisted_15 = ["required", "aria-required"]
const _hoisted_16 = {
  key: 0,
  class: "makler-info"
}
const _hoisted_17 = ["required", "aria-required"]
const _hoisted_18 = ["required", "aria-required"]
const _hoisted_19 = ["required", "aria-required"]
const _hoisted_20 = ["required", "aria-required"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Steps = _resolveComponent("Steps")!
  const _component_ueberschrift = _resolveComponent("ueberschrift")!
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_zeile = _resolveComponent("zeile")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_ja_nein_radio = _resolveComponent("ja-nein-radio")!
  const _component_infotext = _resolveComponent("infotext")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Steps, {
      items: _ctx.navItems,
      active: 0
    }, null, 8, ["items"]),
    _createElementVNode("section", null, [
      _createVNode(_component_ueberschrift, { titel: "Angaben zum Gebäude/Grundstück" }),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_titel_zelle, null, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createElementVNode("strong", null, "Was", -1),
              _createTextVNode(" möchten Sie versichern?")
            ])),
            _: 1,
            __: [22]
          }),
          _createVNode(_component_zelle, { class: "iconRadioHuG" }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                id: "modul1",
                name: "modul",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck) = $event)),
                type: "radio",
                value: false,
                required: "",
                tabindex: "0",
                autofocus: "",
                class: "no-outline",
                "aria-required": "true",
                "aria-label": "Gebäude",
                "data-fehlermeldung": "Bitte wählen Sie, was Sie versichern möchten.",
                "data-cy": "versichertesObjektGebaeude"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck]
              ]),
              _cache[23] || (_cache[23] = _createElementVNode("label", {
                class: "radiolabel",
                for: "modul1",
                style: {"display":"inline-block","padding-right":"0"}
              }, null, -1)),
              _withDirectives(_createElementVNode("input", {
                id: "modul2",
                name: "modul",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck) = $event)),
                type: "radio",
                value: true,
                class: "no-outline",
                tabindex: "0",
                "aria-required": "true",
                "aria-label": "Grundstück",
                "data-cy": "versichertesObjektGrundstueck"
              }, null, 512), [
                [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("label", {
                class: "radiolabel",
                for: "modul2",
                style: {"display":"inline-block","padding-right":"0"}
              }, null, -1))
            ]),
            _: 1,
            __: [23,24]
          })
        ]),
        _: 1
      }),
      (_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === true)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[25] || (_cache[25] = [
                  _createElementVNode("strong", null, "Größe", -1),
                  _createTextVNode(" des Grundstücks in m"),
                  _createElementVNode("sup", null, "2", -1)
                ])),
                _: 1,
                __: [25]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "flaecheUnbebaut",
                    name: "flaecheUnbebaut",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.flaecheUnbebautesGrundstueck) = $event)),
                    class: "c-form-control__input",
                    min: "1",
                    max: "5000",
                    required: _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === true,
                    "aria-required": _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === true,
                    "aria-label": "Größe des Grundstücks in Quadratmetern",
                    "data-fehlermeldung": "Bitte geben Sie eine Fläche zwischen 1 und 5000 m² ein.",
                    "data-cy": "grundstueckFlaeche",
                    placeholder: "m²"
                  }, null, 40, _hoisted_1), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.flaecheUnbebautesGrundstueck,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.flaecheUnbebaut
                  }, null, 8, ["fehler-text"]),
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "u-copy-s gev19-infotext--grey" }, " Wir versichern unbebaute Grundstücke mit Ausnahme von Fluss-, See- und Meergrundstücken sowie Grundstücken, auf denen sich überwiegend Energieerzeugungsanlagen befinden. ", -1))
                ]),
                _: 1,
                __: [26]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[27] || (_cache[27] = [
                  _createTextVNode("Sind Sie Alleineigentümer des Gebäudes?")
                ])),
                _: 1,
                __: [27]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ja_nein_radio, {
                    modelValue: _ctx.piniaStore.state.gebaeudedaten.alleineigentuemer,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.alleineigentuemer) = $event)),
                    name: "alleineigentuemer"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.alleineigentuemer
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
        _ctx.piniaStore.state.gebaeudedaten.alleineigentuemer === false
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 2 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[28] || (_cache[28] = [
                  _createTextVNode("Art der Miteigentümerschaft")
                ])),
                _: 1,
                __: [28]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    name: "miteigentuemerTyp",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.miteigentuemerTyp) = $event)),
                    class: "c-form-control-select",
                    "data-cy": "miteigentuemerTyp",
                    "data-fehlermeldung": "Bitte wählen Sie eine Art der Miteigentümerschaft aus.",
                    required: _ctx.artDerMiteigentuemerschaftRequired,
                    "aria-required": _ctx.artDerMiteigentuemerschaftRequired,
                    "aria-label": "Art der Miteigentümerschaft"
                  }, _cache[29] || (_cache[29] = [
                    _createElementVNode("option", { value: "" }, "Bitte wählen", -1),
                    _createElementVNode("option", { value: "EHE" }, "Ehe-/Lebenspartnerschaft", -1),
                    _createElementVNode("option", { value: "ETG" }, "Eigentümergemeinschaft (EG)", -1),
                    _createElementVNode("option", { value: "WEG" }, "Wohnungseigentümergemeinschaft (WEG)", -1)
                  ]), 8, _hoisted_2), [
                    [_vModelSelect, _ctx.piniaStore.state.gebaeudedaten.miteigentuemerTyp]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.miteigentuemerTyp,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 3 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "gebaeudetypInfo"
              }, {
                default: _withCtx(() => _cache[30] || (_cache[30] = [
                  _createElementVNode("strong", null, "Nutzungsart", -1)
                ])),
                _: 1,
                __: [30]
              }),
              _createVNode(_component_zelle, null, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("select", {
                    id: "modul3",
                    name: "modul",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudetyp) = $event)),
                    class: "c-form-control-select",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                    required: _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false,
                    "aria-required": _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false,
                    "aria-label": "Gebäudetyp",
                    "data-cy": "gebaeudeTyp"
                  }, [
                    (_ctx.eigentuemerschaftIstWEG)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_4, "Bitte wählen"))
                      : _createCommentVNode("", true),
                    (!_ctx.eigentuemerschaftIstWEG)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_5, "Mehrfamilienhaus"))
                      : _createCommentVNode("", true),
                    (!_ctx.eigentuemerschaftIstWEG)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_6, "Einfamilienhaus"))
                      : _createCommentVNode("", true),
                    (!_ctx.eigentuemerschaftIstWEG)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_7, "Vermietete Eigentumswohnung"))
                      : _createCommentVNode("", true),
                    (_ctx.eigentuemerschaftIstWEG && _ctx.piniaStore.state.gebaeudedaten.alleineigentuemer === false)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_8, " WEG Gemeinschafts-, Sonder- und Teileigentum "))
                      : _createCommentVNode("", true),
                    (_ctx.eigentuemerschaftIstWEG && _ctx.piniaStore.state.gebaeudedaten.alleineigentuemer === false)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_9, " WEG Gemeinschaftseigentum "))
                      : _createCommentVNode("", true),
                    (_ctx.stellplaetzeGaragenVersicherbar)
                      ? (_openBlock(), _createElementBlock("option", _hoisted_10, "Garage und/oder Stellplätze"))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_3), [
                    [_vModelSelect, _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.modul,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_zelle, { breite: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_infotext, {
                        name: "gebaeudetypInfo",
                        "css-klassen": "o-grid__cell--no-space"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("ul", _hoisted_11, [
                            _cache[32] || (_cache[32] = _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "Einfamilienhaus"),
                              _createElementVNode("br"),
                              _createTextVNode(" Das Einfamilienhaus wird ausschließlich zu privaten Zwecken genutzt. Bei einer gewerblichen Nutzung wählen Sie bitte die Nutzungsart Mehrfamilienhaus ")
                            ], -1)),
                            _cache[33] || (_cache[33] = _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "Mehrfamilienhaus"),
                              _createElementVNode("br"),
                              _createTextVNode(" Das Mehrfamilienhaus kann sowohl privat als auch gewerblich genutzt sein ")
                            ], -1)),
                            _cache[34] || (_cache[34] = _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "WEG Gemeinschafts-, Sonder-, Teileigentum"),
                              _createElementVNode("br"),
                              _createTextVNode(" Mit dieser Nutzungsart kann sowohl das Gemeinschafts- als auch das Sonder- und Teileigentum einer Wohnungseigentümergemeinschaft (WEG) versichert werden ")
                            ], -1)),
                            _cache[35] || (_cache[35] = _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "WEG Gemeinschaftseigentum"),
                              _createElementVNode("br"),
                              _createTextVNode(" Mit dieser Nutzungsart kann das Gemeinschaftseigentum einer Wohnungseigentümergemeinschaft (WEG) versichert werden ")
                            ], -1)),
                            _cache[36] || (_cache[36] = _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "Vermietete Eigentumswohnung"),
                              _createElementVNode("br"),
                              _createTextVNode(" Mit dieser Nutzungsart kann das Sondereigentum aus dem Besitz von zu privaten Wohnzwecken vermieteten Eigentumswohnungen innerhalb eines Wohngebäudes versichert werden ")
                            ], -1)),
                            (_ctx.stellplaetzeGaragenVersicherbar)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_12, _cache[31] || (_cache[31] = [
                                  _createElementVNode("strong", null, "Garagen und/oder Stellplätze", -1),
                                  _createElementVNode("br", null, null, -1),
                                  _createTextVNode(" Mit dieser Nutzungsart können Garagen und/oder Stellplätze versichert werden ")
                                ])))
                              : _createCommentVNode("", true),
                            _cache[37] || (_cache[37] = _createElementVNode("li", null, [
                              _createElementVNode("strong", null, "Allgemeiner Hinweis"),
                              _createElementVNode("br"),
                              _createTextVNode(" Gebäude mit folgender Nutzung können "),
                              _createElementVNode("strong", null, "nicht"),
                              _createTextVNode(" versichert werden: "),
                              _createElementVNode("ul", null, [
                                _createElementVNode("li", null, "Zum Abriss bestimmte Gebäude"),
                                _createElementVNode("li", null, "Wohnheime ohne abgeschlossene Wohnungen mit z. B. Gemeinschaftsküchen oder -bädern"),
                                _createElementVNode("li", null, "Gebäude, die gegen den Willen des Eigentümers besetzt sind (Hausbesetzung)")
                              ])
                            ], -1))
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0002' &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0006'
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 4 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[38] || (_cache[38] = [
                  _createElementVNode("strong", null, "Anzahl", -1),
                  _createTextVNode(" der Wohnungen")
                ])),
                _: 1,
                __: [38]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "anzahlWohnungen",
                    name: "anzahlWohnungen",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.anzahlWohnungen) = $event)),
                    class: "c-form-control__input",
                    min: _ctx.minAnzahlWohnungen,
                    max: "999",
                    required: _ctx.anzahlWohnungenRequired,
                    "aria-required": _ctx.anzahlWohnungenRequired,
                    "data-fehlermeldung": _ctx.fehlermeldungAnzahlWohnungen,
                    "aria-label": "Anzahl der Wohnungen",
                    "data-cy": "anzahlWohnungen"
                  }, null, 40, _hoisted_13), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.anzahlWohnungen,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.anzahlWohnungen
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp === '0006'
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[39] || (_cache[39] = [
                  _createElementVNode("strong", null, "Anzahl", -1),
                  _createTextVNode(" der Garagen und/oder Stellplätze")
                ])),
                _: 1,
                __: [39]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "anzahlStellplaetzeGaragen",
                    name: "anzahlStellplaetzeGaragen",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.anzahlStellplaetzeGaragen) = $event)),
                    class: "c-form-control__input",
                    min: "1",
                    max: "999",
                    required: _ctx.anzahlStellplaetzeGaragenRequired,
                    "aria-required": _ctx.anzahlStellplaetzeGaragenRequired,
                    "aria-label": "Anzahl der Garagen und/oder Stellplätze",
                    "data-fehlermeldung": "Bitte geben Sie eine Anzahl zwischen 1 und 999 ein.",
                    "data-cy": "anzahlStellplaetzeGaragen"
                  }, null, 40, _hoisted_14), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.anzahlStellplaetzeGaragen,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.anzahlStellplaetzeGaragen
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0002' &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0003' &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0006'
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": !_ctx.piniaStore.state.isMakler,
                "info-box-id": "gewerbeInfo"
              }, {
                default: _withCtx(() => _cache[40] || (_cache[40] = [
                  _createTextVNode(" Befinden sich "),
                  _createElementVNode("strong", null, "Gewerbebetriebe", -1),
                  _createTextVNode(" im Gebäude? ")
                ])),
                _: 1,
                __: [40]
              }, 8, ["zeige-info"]),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden) = $event)),
                    type: "radio",
                    id: "keinGewerbe",
                    name: "gewerbe",
                    value: false,
                    required: _ctx.gewerbeVorhandenRequired,
                    "aria-required": _ctx.gewerbeVorhandenRequired,
                    "aria-label": "Nein, es befinden sich keine Gewerbebetriebe im Gebäude",
                    tabindex: "0",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                    "data-cy": "gewerbeImGebaeude"
                  }, null, 8, _hoisted_15), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden]
                  ]),
                  _cache[42] || (_cache[42] = _createElementVNode("label", {
                    for: "keinGewerbe",
                    class: "radiolabel"
                  }, "Nein", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden) = $event)),
                    type: "radio",
                    id: "gewerbe",
                    name: "gewerbe",
                    value: true,
                    "aria-label": "Ja, es befinden sich Gewerbebetriebe im Gebäude",
                    "data-cy": "noBusinessUse"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden]
                  ]),
                  _cache[43] || (_cache[43] = _createElementVNode("label", {
                    for: "gewerbe",
                    class: "radiolabel"
                  }, "Ja ", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.gewerbe,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_zelle, { breite: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_infotext, {
                        name: "gewerbeInfo",
                        "css-klassen": "o-grid__cell--no-space",
                        text: "Wir versichern keine Gebäude, in denen\n            grundwassergefährdende Stoffe wie beispielsweise\n            Farben, Lacke, Treibstoffe etc. über den\n            haushaltsüblichen Umfang hinaus gelagert werden.<br>\n            Beispiele: Chemische Reinigungen, Tankstellen,\n            Malereibetriebe, Lackierereien, Entsorgungs- und\n            Recyclingbetriebe, Herstellerbetriebe von Farben und\n            Lacken.<br>\n            Wir versichern keine Gebäude in denen sich z. B.\n            folgende Gewerbearten befinden: Stundenhotels,\n            Bordelle, Discotheken, Nachtclubs und Bars."
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.piniaStore.state.isMakler)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[41] || (_cache[41] = [
                        _createTextVNode(" Wir versichern keine Gebäude, in denen grundwassergefährdende Stoffe wie beispielsweise Farben, Lacke, Treibstoffe etc. über den haushaltsüblichen Umfang hinaus gelagert werden."),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" Beispiele: Chemische Reinigungen, Tankstellen, Malereibetriebe, Lackierereien, Entsorgungs- und Recyclingbetriebe, Herstellerbetriebe von Farben und Lacken."),
                        _createElementVNode("br", null, null, -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" Wir versichern keine Gebäude in denen sich z. B. folgende Gewerbearten befinden: Stundenhotels, Bordelle, Spielhallen, Wettbüros, Discotheken, Nachtclubs und Bars. ")
                      ])))
                    : _createCommentVNode("", true)
                ]),
                _: 1,
                __: [42,43]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0002' &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0003' &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0006' &&
        _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden === true
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 7 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => _cache[44] || (_cache[44] = [
                  _createElementVNode("strong", null, "Anzahl", -1),
                  _createTextVNode(" der Gewerbebetriebe")
                ])),
                _: 1,
                __: [44]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "anzahlGewerbebetriebe",
                    name: "anzahlGewerbebetriebe",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeAnzahl) = $event)),
                    class: "c-form-control__input",
                    min: "1",
                    "data-fehlermeldung": "Bitte geben Sie eine Gewerbeanzahl zwischen 1 und 50 ein.",
                    required: _ctx.gewerbeAnzahlRequired,
                    "aria-required": _ctx.gewerbeAnzahlRequired,
                    "aria-label": "Anzahl der Gewerbebetriebe",
                    max: "50",
                    "data-cy": "anzahlGewerbe"
                  }, null, 40, _hoisted_17), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.gewerbeAnzahl,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.anzahlGewerbebetriebe
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.gewerbeAnzahlRequired)
        ? (_openBlock(), _createBlock(_component_zeile, { key: 8 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "zeige-info": true,
                "info-box-id": "gewerbeflaecheInfo"
              }, {
                default: _withCtx(() => _cache[45] || (_cache[45] = [
                  _createElementVNode("strong", null, "Gewerbefläche", -1),
                  _createTextVNode(" in m"),
                  _createElementVNode("sup", null, "2", -1)
                ])),
                _: 1,
                __: [45]
              }),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "flaecheGewerbe",
                    name: "flaecheGewerbe",
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gewerbeflaecheGesamt) = $event)),
                    class: "c-form-control__input",
                    min: "1",
                    "data-fehlermeldung": "\nBitte geben Sie eine Gewerbefläche zwischen 1 und 1000 qm ein.",
                    required: _ctx.gewerbeflaecheRequired,
                    "aria-required": _ctx.gewerbeflaecheRequired,
                    "aria-label": "Gewerbefläche in Quadratmetern",
                    max: "1000",
                    "data-cy": "flaecheGewerbe"
                  }, null, 40, _hoisted_18), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.gewerbeflaecheGesamt,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.flaecheGewerbe
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_zelle, { breite: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_infotext, {
                        name: "gewerbeflaecheInfo",
                        "css-klassen": "o-grid__cell--no-space",
                        text: "Zur Gewerbefläche zählen auch gewerblich genutzte Abstell, Keller- und/oder Bodenräume."
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudetyp !== '0006'
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 9 }, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.wohnungOderGebaude) + " ", 1),
                  _cache[46] || (_cache[46] = _createElementVNode("strong", null, "leerstehend", -1)),
                  _cache[47] || (_cache[47] = _createTextVNode("? "))
                ]),
                _: 1,
                __: [46,47]
              }),
              _createVNode(_component_zelle, { class: "mkRadio" }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung) = $event)),
                    type: "radio",
                    id: "ohneLeerstand",
                    name: "gebaeudenutzung",
                    value: "0000",
                    required: !_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck,
                    "aria-required": !_ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck,
                    "aria-label": "Kein Leerstand",
                    "data-fehlermeldung": "Bitte treffen Sie eine Auswahl",
                    "data-cy": "UnusedSpaceNo"
                  }, null, 8, _hoisted_19), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung]
                  ]),
                  _cache[48] || (_cache[48] = _createElementVNode("label", {
                    for: "ohneLeerstand",
                    class: "radiolabel"
                  }, "Nein", -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung) = $event)),
                    type: "radio",
                    id: "mitLeerstand",
                    name: "gebaeudenutzung",
                    value: "0005",
                    "aria-label": "Leerstand",
                    "data-cy": "UnusedSpace"
                  }, null, 512), [
                    [_vModelRadio, _ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung]
                  ]),
                  _cache[49] || (_cache[49] = _createElementVNode("label", {
                    for: "mitLeerstand",
                    class: "radiolabel"
                  }, "Ja ", -1)),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.gebaeudenutzung,
                    "reduzierter-abstand": true
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1,
                __: [48,49]
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (
        _ctx.piniaStore.state.gebaeudedaten.unbebautesGruendstueck === false &&
        _ctx.piniaStore.state.gebaeudedaten.gebaeudenutzung === '0005'
      )
        ? (_openBlock(), _createBlock(_component_zeile, { key: 10 }, {
            default: _withCtx(() => [
              (_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden)
                ? (_openBlock(), _createBlock(_component_titel_zelle, {
                    key: 0,
                    "zeige-info": _ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden,
                    "info-box-id": "leerstandInfo"
                  }, {
                    default: _withCtx(() => _cache[50] || (_cache[50] = [
                      _createElementVNode("strong", null, "Leerstand", -1),
                      _createTextVNode(" der Gesamtfläche in % ")
                    ])),
                    _: 1,
                    __: [50]
                  }, 8, ["zeige-info"]))
                : (_openBlock(), _createBlock(_component_titel_zelle, { key: 1 }, {
                    default: _withCtx(() => _cache[51] || (_cache[51] = [
                      _createTextVNode("Leerstand der "),
                      _createElementVNode("strong", null, "Gesamtwohnfläche", -1),
                      _createTextVNode(" in %")
                    ])),
                    _: 1,
                    __: [51]
                  })),
              _createVNode(_component_zelle, { breite: 4 }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    onKeydown: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                    id: "leerstand",
                    name: "leerstand",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.piniaStore.state.gebaeudedaten.leerstand) = $event)),
                    class: "c-form-control__input",
                    "data-cy": "flaecheLeerstand",
                    min: "1",
                    max: "100",
                    required: _ctx.leerstandRequired,
                    "aria-required": _ctx.leerstandRequired,
                    tabindex: "0",
                    "aria-label": "Leerstand in Prozent",
                    "data-fehlermeldung": "Bitte geben Sie einen Prozentwert zwischen 1 und 100 ein."
                  }, null, 40, _hoisted_20), [
                    [
                      _vModelText,
                      _ctx.piniaStore.state.gebaeudedaten.leerstand,
                      void 0,
                      {
                        lazy: true,
                        trim: true,
                        number: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.leerstand
                  }, null, 8, ["fehler-text"]),
                  _createVNode(_component_zelle, { breite: 8 }, {
                    default: _withCtx(() => [
                      (_ctx.piniaStore.state.gebaeudedaten.gewerbeVorhanden)
                        ? (_openBlock(), _createBlock(_component_infotext, {
                            key: 0,
                            name: "leerstandInfo",
                            "css-klassen": "o-grid__cell--no-space",
                            text: "Zur Gesamtfläche zählen alle Wohn- und Gewerbeflächen."
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_zeile, null, {
        default: _withCtx(() => [
          _createVNode(_component_zelle, {
            breite: 3,
            offset: 4
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "c-button c-button--full-width u-mar-t-2 u-mar-b-2 mobil-mehrAbstand",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
                "data-cy": "submitZumVergleich"
              }, " Weiter zum Vergleich ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}